import React from 'react';

const FieldHint = ({text}) =>
{
  return (
    <span className="utv-hint">{text}</span>
  );
}

export default FieldHint;
